import {Controller} from '@stubhub/react-store-provider';

import {showGoogleResellerDisclaimerSelector} from './selectors';

const NAMESPACE = 'googleSemMessage';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const showDisclaimerEnabled = showGoogleResellerDisclaimerSelector(state);

    return {
      showDisclaimerEnabled,
    };
  },
});

export default controller;
